export function getUTMParams() {
  const targetParams = [
    'utm_source', 'utm_campaign', 'utm_medium', 'utm_term', 
    'utm_content', 'utm_id', 'fbclid', 'fb_ad'
  ];
  
  const defaults = {
    utm_source: 'haveibeenbreached',
    utm_medium: 'breach_status',
    utm_campaign: 'haveibeenbreached',
    utm_term: 'hibb'
  };
  
  const urlParams = new URLSearchParams(window.location.search);
  const extractedParams = {};
  
  targetParams.forEach(param => {
    const value = urlParams.get(param);
    if (value) {
      extractedParams[param] = value;
    }
  });
  
  const finalParams = { ...defaults, ...extractedParams };
  
  return Object.entries(finalParams)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');
}